<div class="card mb-3">
  <div class="card-header">
    {{ 'shared.components.image_card.title' | translate }} {{ titleAppendix | translate }}
  </div>
  <div class="card-body">


    <ul class="list-group" >
      <li class="list-group-item d-flex justify-content-between align-items-center" *ngIf="formControl.value">
        {{ formControl.value!.name }}
        <div class="btn-group-sm btn-group"><button class="btn btn-sm btn-primary" (click)="openFile()" type="button" ><i class="fa fa-download"></i></button><button class="btn btn-sm btn-danger" (click)="formControl.setValue(null)" type="button" ><i class="fa fa-times"></i></button></div></li>
    </ul>

    <div class="mt-2 btn btn-secondary w-100" (click)="openModal()">
      {{ 'shared.components.image_card.select_image' | translate }}
    </div>

    <p class="mt-2 text-muted">
      {{ 'shared.components.image_card.warning_public' | translate }}
    </p>

  </div>
</div>



<ng-template #selectImageModalTemplate>

    <app-file-manager
      class="h-100"
      [limitSelectToOneFile]="true"
      [limitToImages]="true"
    (filesSelected)="imageSelected($event)"
    (requestClose)="selectImageModal?.hide()"
    >

    </app-file-manager>
</ng-template>
